import { Injectable } from '@angular/core';
import { AuthBackendServer } from '@shared/apis/servers/auth.backend.server';
import { HttpClient } from '@angular/common/http';
import { MasterBackendServer } from '@shared/apis/servers/master.backend.server';
import { UserBackendServer } from '@shared/apis/servers/user.backend.server';
import { TicketBackendServer } from '@shared/apis/servers/ticket.backend.server';
import { BpBackendServer } from '@shared/apis/servers/bp.backend.server';
import { ProductBackendServer } from '@shared/apis/servers/product.backend.server';
import { DealerBackendServer } from '@shared/apis/servers/dealer.backend.server';
import { Sc4uBackendServer } from '@shared/apis/servers/sc4u.backend.server';
import { LocatorBackendServer } from '@shared/apis/servers/locator.backend.server';
import { CompanyBackendServer } from '@shared/apis/servers/company.backend.server';
import { PortalBackendServer } from '@shared/apis/servers/portal.backend.server';
import { SummaryBackendServer } from '@shared/apis/servers/summary.backend.server';
import { ConcealedDamageBackendServer } from '@shared/apis/servers/concealed-damage.backend.server';
import { PurchasePlaceBackendServer } from '@shared/apis/servers/purchase-place.backend.server';
import { AccessDataBackendServer } from '@shared/apis/servers/access-data.backend.server';
import { SalesDataBackendServer } from '@shared/apis/servers/sales-data.backend';
import { CaseBackendServer } from '@shared/apis/servers/case.backend.server';
import { B2bTicketBackendServer } from '@shared/apis/servers/b2b-ticket.backend.server';
import { RsmEscalationBackendServer } from '@shared/apis/servers/rsm-escalation.backend.server';
import { ZipCodeBackendServer } from '@shared/apis/servers/zip-code.backend.server';
import { ExtendSerialBackendServer } from '@shared/apis/servers/extend-serial.backend.server';
import { InquiryBackendServer } from '@shared/apis/servers/inquiry.backend.server';
import { TrainingVideoBackendServer } from '@shared/apis/servers/training-video.backend.server';

@Injectable({
  providedIn: 'root'
})
export class ApiServer {
  public backend: AuthBackendServer;
  public trainingVideo: TrainingVideoBackendServer;
  public master: MasterBackendServer;
  public user: UserBackendServer;
  public dealer: DealerBackendServer;
  public summary: SummaryBackendServer;
  public bp: BpBackendServer;
  public sc4u: Sc4uBackendServer;
  public product: ProductBackendServer;
  public ticket: TicketBackendServer;
  public locator: LocatorBackendServer;
  public company: CompanyBackendServer;
  public purchasePlace: PurchasePlaceBackendServer;
  public portal: PortalBackendServer;
  public concealedDamage: ConcealedDamageBackendServer;
  public accessData: AccessDataBackendServer;
  public salesData: SalesDataBackendServer;
  public case: CaseBackendServer;
  public rsmEscalation: RsmEscalationBackendServer;
  public b2bTicket: B2bTicketBackendServer;
  public zipCode: ZipCodeBackendServer;
  public extendSerial: ExtendSerialBackendServer;
  public inquiry: InquiryBackendServer;

  constructor(private httpClient: HttpClient) {
    this.backend = new AuthBackendServer(httpClient);
    this.master = new MasterBackendServer(httpClient);
    this.user = new UserBackendServer(httpClient);
    this.dealer = new DealerBackendServer(httpClient);
    this.summary = new SummaryBackendServer(httpClient);
    this.bp = new BpBackendServer(httpClient);
    this.sc4u = new Sc4uBackendServer(httpClient);
    this.product = new ProductBackendServer(httpClient);
    this.ticket = new TicketBackendServer(httpClient);
    this.locator = new LocatorBackendServer(httpClient);
    this.company = new CompanyBackendServer(httpClient);
    this.portal = new PortalBackendServer(httpClient);
    this.concealedDamage = new ConcealedDamageBackendServer(httpClient);
    this.purchasePlace = new PurchasePlaceBackendServer(httpClient);
    this.accessData = new AccessDataBackendServer(httpClient);
    this.salesData = new SalesDataBackendServer(httpClient);
    this.case = new CaseBackendServer(httpClient);
    this.rsmEscalation = new RsmEscalationBackendServer(httpClient);
    this.b2bTicket = new B2bTicketBackendServer(httpClient);
    this.zipCode = new ZipCodeBackendServer(httpClient);
    this.extendSerial = new ExtendSerialBackendServer(httpClient);
    this.inquiry = new InquiryBackendServer(httpClient);
    this.trainingVideo = new TrainingVideoBackendServer(httpClient);
  }
}
